import { Dropdown } from 'bootstrap';
import '../image-protection';

export function initHeader() {
    const navbar = document.getElementById('header_section');
    const burger = document.getElementById('nav-icon4');
    const menu = document.getElementById('navbarMenu');
    const scrollThreshold = 10;

    if (navbar) {
        window.addEventListener('scroll', function () {
            navbar.classList.toggle('scrolled', window.scrollY > scrollThreshold);
        });
    }

    if (burger && menu) {
        burger.addEventListener('click', function () {
            burger.classList.toggle('open');
            menu.classList.toggle('active');
        });
    }
}

export function initHeaderDropdowns() {
    document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(toggle => {
        Dropdown.getOrCreateInstance(toggle);
    });
}

export function initPublicHeader() {
    initHeader();
    initHeaderDropdowns();
}
